import { motion } from "framer-motion";
import { Star, Shield, Users, Award } from "lucide-react";
import { fadeUp, stagger, viewportOnce } from "../utils/motionVariants";

const TRUST_ITEMS = [
  { icon: Star, label: "Google Reviews", value: "5.0 Rating" },
  { icon: Users, label: "UK Businesses", value: "100s" },
  { icon: Shield, label: "Elavon Partner", value: "FCA Regulated" },
  { icon: Award, label: "UK-Based Support", value: "Real People" },
];

export default function TrustBar() {
  return (
    <section className="py-6 bg-white border-y border-brand-light-grey/50" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={viewportOnce} variants={stagger} className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
          {TRUST_ITEMS.map((item) => (
            <motion.div key={item.label} variants={fadeUp} className="flex items-center gap-2.5">
              <item.icon size={18} className="text-brand-aqua flex-shrink-0" />
              <div>
                <p className="text-xs font-bold text-brand-black leading-tight">{item.value}</p>
                <p className="text-[10px] text-brand-grey uppercase tracking-wider">{item.label}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
